.ax{justify-content:center;}